module.exports = __webpack_public_path__ + "static/media/eirgrid.b1d839d3.png";